import React, { useState } from "react";
import { FiArrowRight, FiMail, FiMapPin } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", order: "", subject: "Product question", message: "" });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((data) => ({ ...data, [name]: value }));
    if (errors[name]) setErrors((current) => ({ ...current, [name]: "" }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!formData.firstName.trim()) nextErrors.firstName = "Please add your first name";
    if (!formData.email.match(/^\S+@\S+\.\S+$/)) nextErrors.email = "Please enter a valid email";
    if (formData.message.trim().length < 10) nextErrors.message = "Tell us a little more so we can help";
    if (Object.keys(nextErrors).length) { setErrors(nextErrors); return; }
    setIsSubmitting(true);
    window.setTimeout(() => { setIsSubmitting(false); setShowSuccess(true); setFormData({ firstName: "", lastName: "", email: "", order: "", subject: "Product question", message: "" }); }, 700);
  };

  const input = (name, label, type = "text") => (
    <label className={errors[name] ? "has-error" : ""}><span>{label}</span><input type={type} name={name} value={formData[name]} onChange={handleInputChange} />{errors[name] && <small>{errors[name]}</small>}</label>
  );

  return (
    <main className="contact-page page-shell section-space">
      <header className="contact-heading"><p className="eyebrow">Customer care</p><h1>Let’s talk about paper.</h1><p>Questions about a product, your order or the right notebook for your favourite pen? We would love to help.</p></header>
      <div className="contact-layout">
        <aside>
          <div><FiMail /><h2>Write to us</h2><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><p>We usually respond {siteConfig.contact.responseTime}.</p></div>
          <div><FiMapPin /><h2>Our studio</h2><p>{siteConfig.contact.location}<br />Online shop only</p></div>
          <div className="contact-hours"><h2>Customer care hours</h2><p>Monday–Friday<br />09:00–16:00 CET</p></div>
        </aside>
        <section>
          {showSuccess ? <div className="contact-success" role="status"><span>✓</span><h2>Your message is with us.</h2><p>Thank you for writing. We’ll reply {siteConfig.contact.responseTime}.</p><button type="button" className="text-link" onClick={() => setShowSuccess(false)}>Send another note <FiArrowRight /></button></div> : (
            <form onSubmit={handleSubmit} noValidate>
              <div className="contact-two">{input("firstName", "First name *")}{input("lastName", "Last name")}</div>
              <div className="contact-two">{input("email", "Email *", "email")}{input("order", "Order number (optional)")}</div>
              <label><span>What can we help with?</span><select name="subject" value={formData.subject} onChange={handleInputChange}><option>Product question</option><option>Order update</option><option>Shipping & delivery</option><option>Return or refund</option><option>Just saying hello</option></select></label>
              <label className={errors.message ? "has-error" : ""}><span>Message *</span><textarea name="message" rows="7" value={formData.message} onChange={handleInputChange} />{errors.message && <small>{errors.message}</small>}</label>
              <button className="button" type="submit" disabled={isSubmitting}>{isSubmitting ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </section>
      </div>
    </main>
  );
}

export default Contact;
